import { Button, Card, Icon } from "@sellar-io/components";
import { twMerge } from "tailwind-merge";

export const DeliveredBySellarPrompt = ({
  hasItems = false,
  onTurnOn,
  className,
}: {
  hasItems?: boolean;
  onTurnOn: () => void;
  className?: string;
}) => (
  <Card
    className={twMerge(
      "flex flex-col gap-2 border border-purple-300 bg-purple-50 p-3",
      className,
    )}
  >
    <div className="flex flex-col gap-1 text-sm">
      <p className="font-semibold text-zinc-800">
        {hasItems ? "Continue building your " : "Build your "}
        <span className="text-purple-600">Delivered by Sellar</span> basket
      </p>
      <p className="text-xs text-zinc-600">
        {hasItems
          ? "Don’t miss the cut-off! Build your order with a range of makers and get it all delivered together by Sellar"
          : "Build your basket on the Market with the full range of makers Delivered by Sellar, and get it all delivered together"}
      </p>
    </div>
    <Button
      color={hasItems ? "secondary" : "slim"}
      onClick={onTurnOn}
      className={hasItems ? "w-full" : "w-full bg-[#A34FD2] text-white"}
    >
      {!hasItems && <Icon icon="STAR_SHINE" />}
      {hasItems ? "Continue shopping" : "Try it"}
    </Button>
  </Card>
);
